/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/



// function initMobileMegaMenu() {
//   if (!window.matchMedia('(max-width: 768px)').matches) return;

//   document.querySelectorAll('a.main-linklist-link').forEach(link => {
//     link.addEventListener('click', function (e) {
//       e.preventDefault();

//       const megamenu = this.nextElementSibling;
//       if (!megamenu || !megamenu.classList.contains('main-megamenu')) return;

//       const isActive = megamenu.classList.contains('active');

//       document.querySelectorAll('.main-megamenu').forEach(m => {
//         m.classList.remove('active');
//       });

//       if (!isActive) {
//         megamenu.classList.add('active');
//       }
//     });
//   });
// }

// document.addEventListener('DOMContentLoaded', initMobileMegaMenu);

function initMobileMegaMenu() {
  if (!window.matchMedia('(max-width: 768px)').matches) return;

  document.querySelectorAll('a.main-linklist-link').forEach(link => {
    link.addEventListener('click', function (e) {

      const megamenu = this.nextElementSibling;

      // ✅ NO megamenu → allow normal click
      if (!megamenu || !megamenu.classList.contains('main-megamenu')) {
        return;
      }

      // ✅ Has megamenu → toggle only
      e.preventDefault();

      const isActive = megamenu.classList.contains('active');

      document.querySelectorAll('.main-megamenu').forEach(m => {
        m.classList.remove('active');
      });

      if (!isActive) {
        megamenu.classList.add('active');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initMobileMegaMenu);



document.querySelector('.header_mobile_openbutton')?.addEventListener('click', function (e) {
  e.preventDefault();
  document.querySelector('.header__wrapper')?.classList.toggle('active');
});





const QuantityButton = document.querySelectorAll('.quantity-button');
if (QuantityButton.length > 0) {
QuantityButton.forEach(button => {
  button.addEventListener('click', function() {
    const discountValue = this.getAttribute('data-discount');
    const discountTag = document.querySelector('.product-card-discount-tag span');
    if (discountValue && discountTag) {
      discountTag.textContent = discountValue;
    }
  });
});
}


document.querySelectorAll('.shopify-policy__body ul li p').forEach(p => {
  const spans = p.querySelectorAll('span');
  if (spans.length === 2) {
    spans[0].style.fontWeight = '700';
  }
});
(function() {
  // Add custom code below this line


const ReviewSlider = new Swiper('.review-swiper-slider', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 15,
  navigation: {
    nextEl: '.home-review-section .swiper-button-next',
    prevEl: '.home-review-section .swiper-button-prev'
  },
  pagination: {
    el: '.home-review-section .swiper-pagination',
    clickable: true
  },
  breakpoints: {
    750: {
      slidesPerView: 1.5,
      spaceBetween: 20
    },
    990: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    1260: {
      slidesPerView: 3,
      spaceBetween: 24
    }
  }
});

const ReviewCard = new Swiper('.pdp-review-card-slider', {
  loop: false,
  slidesPerView: 1.1,
  spaceBetween: 5,
   navigation: {
    nextEl: '.tr-section .swiper-button-next',
    prevEl: '.tr-section .swiper-button-prev'
  },
  breakpoints: {
    750: {
      slidesPerView: 1.6,
      spaceBetween: 10
    },
    990: {
      slidesPerView: 1.6,
      spaceBetween: 10
    }, 
    1260: {
      slidesPerView: 2,
      spaceBetween: 16
    }
  }
});

const CPS_slider = new Swiper('.cps-block', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 15,
  navigation: {
    nextEl: '.cps-section .swiper-button-next',
    prevEl: '.cps-section .swiper-button-prev'
  },
  pagination: {
    el: '.cps-section .swiper-pagination',
    clickable: true
  },
  breakpoints: {
    750: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    990: {
      slidesPerView: 3,
      spaceBetween: 20
    },
    1260: {
      slidesPerView: 4,
      spaceBetween: 23
    }
  }
});
const sliderEl = document.querySelector('.pdp-pc-slider');
let enableLoop = false; // define outside so it's available globally

if (sliderEl) {
  const slideCount = sliderEl.querySelectorAll('.swiper-slide').length;
  enableLoop = slideCount > 3;

  const pdp_product_slider = new Swiper(sliderEl, {
    loop: enableLoop,
    slidesPerView: 1,
    spaceBetween: 15,
    navigation: {
      nextEl: '.pdp-product-list-section .swiper-button-next',
      prevEl: '.pdp-product-list-section .swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      750: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      990: {
        slidesPerView: 3,
        spaceBetween: 24
      }
    }
  });
}


  
  
let collectionSlider = null;

function initCollectionSlider() {
  if (window.innerWidth >= 750 && collectionSlider === null) {
    collectionSlider = new Swiper('.collection-product-slider.swiper', {
      loop: true,
      slidesPerView: 1.2,
      spaceBetween: 15,
      navigation: {
        nextEl: '.home-product-slider .swiper-button-next',
        prevEl: '.home-product-slider .swiper-button-prev'
      },
      pagination: {
        el: '.home-product-slider .swiper-pagination',
        clickable: true
      },
      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1260: {
          slidesPerView: 4,
          spaceBetween: 23
        }
      }
    });
  } else if (window.innerWidth < 750 && collectionSlider !== null) {
    collectionSlider.destroy(true, true);
    collectionSlider = null;
  }
}
initCollectionSlider();

window.addEventListener('resize', function () {
  initCollectionSlider();
});



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();



// Blog page load more article btn script
function pagination_click_fun(){
  let loadMoreBtn = document.querySelector("[data-pagination-btn]") || null;
  if(loadMoreBtn){
    loadMoreBtn.addEventListener("click",function(e) {
      e.preventDefault();
      pagination_items_get_fun(loadMoreBtn.getAttribute("href"));
    });
  }
}
  if(document.body.classList.contains('template-blog')){
    if(window.location.href.includes('?page=')){
      window.location.replace(window.location.href.split('?')[0]);
    }
  }
pagination_click_fun();
function pagination_items_get_fun(loadMoreBtn){
  fetch(loadMoreBtn)
  .then(response => {
  return response.text();
  })
  .then(response => {
    
    const parser = new DOMParser();
    const html = parser.parseFromString(response, "text/html");
    let proGrid = document.querySelector("[data-product-main-wrapper]");
    if(proGrid){
      // replace product grid HTML
      proGrid.innerHTML = document.querySelector("[data-product-main-wrapper]").innerHTML + html.querySelector("[data-product-main-wrapper]").innerHTML;
      // replace pagination HTML
      window.history.replaceState({}, null, loadMoreBtn); // added curent pagination link
      let pagination = document.querySelector("[data-pagination-link]");
      let newPagination = html.querySelector("[data-pagination-link]");
      if(pagination && newPagination){
        pagination.innerHTML = newPagination.innerHTML;
        pagination_click_fun(); // reinit click event
      }
      // get_cusrom_bundle_product();
      // let custom_bundal = document.querySelector("[data-custom-bundal-main-wapper]") || null;
      // if(custom_bundal){
      //   get_cusrom_bundle_product();
      // }     
    }
  });
}

document.querySelector('.thumbs-next')?.addEventListener('click', function () {
  document.querySelector('.slider__button--next')?.click();
});
document.querySelector('.thumbs-prev')?.addEventListener('click', function () {
  document.querySelector('.slider__button--prev')?.click();
});



document.addEventListener('click', function (e) {

  const popup = document.querySelector('.safety-popup');
  const overlay = document.querySelector('.safety-popup-overlay');
  const body = document.body;

  if (e.target.closest('.popup-opener-button')) {
    e.preventDefault();
    popup?.classList.add('active');
    overlay?.classList.add('active');
    body.classList.add('injection-safety-popup');
  }

  if (
    e.target.closest('.popup-close-icon') ||
    e.target.classList.contains('safety-popup-overlay')
  ) {
    popup?.classList.remove('active');
    overlay?.classList.remove('active');
    body.classList.remove('injection-safety-popup');
  }

});



const InjectionGalleryThumbnail = new Swiper('.main-thumbnail-gallery', {
  slidesPerView: 'auto',
  spaceBetween: 8,
  loop: true,
  watchSlidesProgress: true,
});

const InjectionGallery = new Swiper('.main-image-gallery', {
  slidesPerView: 1,
  spaceBetween: 10,
  effect: 'fade',
  loop: true,
  thumbs: {
    swiper: InjectionGalleryThumbnail
  },
  navigation: {
    nextEl: ".slider__button--next",
    prevEl: ".slider__button--prev"
  }
});



const ThemeCustomThumbsGallery = new Swiper('.theme-main-thumbs-slider', {
  slidesPerView: 'auto',
  spaceBetween: 8,
  loop: false,
  watchSlidesProgress: true,
});

const ThemeCustomGallery = new Swiper('.theme-product-custom-slider', {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: false,
  navigation: {
    nextEl: ".slider__button--next",
    prevEl: ".slider__button--prev"
  },
  thumbs: {
    swiper: ThemeCustomThumbsGallery
  }
}); 







let PRODUCT_DATA = null;

// Cache DOM
const DOM = {
  mapEl: document.querySelector('[data-variant-meta-map]'),
  priceBox: document.querySelector(".price-box"),
  mainPrice: document.querySelectorAll(".product-main-price"),
  subPrice: document.querySelectorAll(".subprice-text"),
  prefix: document.querySelectorAll(".price-prefix sub"),
  checkoutBtns: document.querySelectorAll(".variant-checkout-link"),
  groups: document.querySelectorAll(".product-option"),
  handle: document.querySelector("[data-product-handle]")?.dataset.productHandle
};

// Parse map once
let VARIANT_MAP = {};
try {
  VARIANT_MAP = JSON.parse(DOM.mapEl?.textContent || '{}');
} catch (e) {}


// Fetch product once
async function getProduct() {
  if (PRODUCT_DATA) return PRODUCT_DATA;

  if (!DOM.handle) return null;

  const res = await fetch(`/products/${DOM.handle}.js`);
  PRODUCT_DATA = await res.json();
  return PRODUCT_DATA;
}


// Format money
const formatMoney = cents =>
  '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');


// Update UI (meta + checkout)
function updateVariantUI(variantId) {
  const data = VARIANT_MAP[String(variantId)];
  if (!data) return;

  // Checkout link
  DOM.checkoutBtns.forEach(el => {
    if (data.checkoutLink?.trim()) {
      el.href = data.checkoutLink;
      el.style.display = '';
    } else {
      el.removeAttribute('href');
      el.style.display = 'none';
    }
  });

  // Price prefix
  if (data.pricePrefix) {
    DOM.prefix.forEach(el => {
      el.textContent = data.pricePrefix;
      el.classList.toggle(
        "show_onemonth-price",
        data.pricePrefix === "First Month"
      );
    });
  }
}


// Get selected values
function getSelectedValues() {
  const values = [];

  DOM.groups.forEach(group => {
    const active = group.querySelector(".product-variant-button.active");
    if (active) values.push(active.textContent.trim());
  });

  return values.length === DOM.groups.length ? values : null;
}


// Find variant (FAST)
function findVariant(product, selectedValues) {
  return product.variants.find(v =>
    selectedValues.every((val, i) => v.options[i] === val)
  );
}


// Update price UI
function updatePrice(variant) {
  DOM.mainPrice.forEach(el => {
    el.textContent = formatMoney(variant.price);
  });

  DOM.subPrice.forEach(el => {
    if (variant.compare_at_price) {
      el.textContent = formatMoney(variant.compare_at_price);
      el.style.display = "";
    } else {
      el.style.display = "none";
    }
  });
}


// Click handler
document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".product-variant-button");
  if (!btn || btn.disabled) return;

  const parent = btn.closest(".product-option");

  // Active toggle
  parent.querySelectorAll(".product-variant-button")
    .forEach(b => b.classList.remove("active"));
  btn.classList.add("active");

  // Auto select missing groups
  DOM.groups.forEach(group => {
    if (group !== parent && !group.querySelector(".active")) {
      group.querySelector(".product-variant-button:not([disabled])")
        ?.classList.add("active");
    }
  });

  const selectedValues = getSelectedValues();
  if (!selectedValues) return;

  DOM.priceBox?.classList.add("is-loading");

  const product = await getProduct();
  if (!product) return;

  const variant = findVariant(product, selectedValues);
  if (!variant) return;

  updatePrice(variant);
  updateVariantUI(variant.id);

  DOM.priceBox?.classList.remove("is-loading");
});


// Initial load
document.addEventListener("DOMContentLoaded", async () => {
  if (!DOM.groups.length) return;

  // Auto select first options
  DOM.groups.forEach(group => {
    group.querySelector(".product-variant-button:not([disabled])")
      ?.classList.add("active");
  });

  const product = await getProduct();
  if (!product) return;

  const firstVariant = product.variants[0];
  if (!firstVariant) return;

  updatePrice(firstVariant);
  updateVariantUI(firstVariant.id);
});